import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
  padding-bottom: 120px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
`;

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: white;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const StepDot = styled.div<{ active: boolean; completed: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.3s;
  
  background: ${props => {
    if (props.completed) return 'linear-gradient(135deg, #10b981 0%, #059669 100%)';
    if (props.active) return 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
    return '#e2e8f0';
  }};
  
  color: ${props => (props.active || props.completed) ? 'white' : '#94a3b8'};
`;

export const StepLine = styled.div<{ completed: boolean }>`
  width: 40px;
  height: 3px;
  border-radius: 2px;
  background: ${props => props.completed ? '#10b981' : '#e2e8f0'};
  transition: all 0.3s;
`;

export const StepLabel = styled.div`
  text-align: center;
  margin-top: 8px;
  font-size: 11px;
  color: #64748b;
`;

export const Title = styled.h2`
  margin: 0 0 16px 0;
  color: #1e293b;
  font-size: 20px;
  font-weight: 700;
`;

